import actionTypes from '../../action-types'

export default (customerProductId) => ({
  type: actionTypes.USER_GROUPS.FETCH_ALL_BADGES,
  payload: {
    customerProductId,
  },
})
